const GOVERNORATES: { en: string; ar: string }[] = [
  { en: "Ad Dakhiliyah", ar: "الداخلية" },
  { en: "Ad Dhahirah", ar: "الظاهرة" },
  { en: "Al Batinah North", ar: "شمال الباطنة" },
  { en: "Al Batinah South", ar: "جنوب الباطنة" },
  { en: "Al Buraimi", ar: "البريمي" },
  { en: "Al Wusta", ar: "الوسطى" },
  { en: "Ash Sharqiyah North", ar: "شمال الشرقية" },
  { en: "Ash Sharqiyah South", ar: "جنوب الشرقية" },
  { en: "Dhofar", ar: "ظفار" },
  { en: "Muscat", ar: "مسقط" },
  { en: "Musandam", ar: "مسندم" },
];

export function getGovernoratesOptions(language: string): Map<string, string> {
  return new Map(
    GOVERNORATES.map(({ en, ar }) => [en, language === "ar" ? ar : en]),
  );
}